import { render, staticRenderFns } from "./faceSubmission.vue?vue&type=template&id=fc933a3a&scoped=true"
import script from "./faceSubmission.vue?vue&type=script&lang=js"
export * from "./faceSubmission.vue?vue&type=script&lang=js"
import style0 from "./faceSubmission.vue?vue&type=style&index=0&id=fc933a3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc933a3a",
  null
  
)

export default component.exports